import { Label } from "@/components/ui/label";
import { Loader2, Check } from "lucide-react";

export function Section({ title, number, hint, children, fullWidth }) {
  return (
    <div className="border-b border-[#33424f]/20 p-6">
      <div className="mb-5">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#39678f] subtitle">
          / {number}
        </div>
        <h3 className="font-display font-bold text-lg mt-1">{title}</h3>
        {hint && <p className="text-xs text-[#50493b] mt-1">{hint}</p>}
      </div>
      <div className={fullWidth ? "grid grid-cols-1 md:grid-cols-3 gap-4" : "grid grid-cols-1 md:grid-cols-3 gap-4"}>
        {children}
      </div>
    </div>
  );
}

// Small inline save indicator shown next to a field in edit mode.
export function SaveIndicator({ state, fieldKey }) {
  if (!state) return null;
  const color =
    state === "error"
      ? "text-[#b30035]"
      : state === "saved"
      ? "text-[#2f7d4f]"
      : "text-[#39678f]";
  return (
    <span
      data-testid={`save-state-${fieldKey}`}
      data-state={state}
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider subtitle ${color}`}
    >
      {state === "saving" && (
        <>
          <Loader2 className="w-3 h-3 animate-spin" /> Saving
        </>
      )}
      {state === "saved" && (
        <>
          <Check className="w-3 h-3" /> Saved
        </>
      )}
      {state === "error" && <>Failed</>}
    </span>
  );
}

export function Field({ label, children, fieldKey, state, error }) {
  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-2 min-h-[16px]">
        <Label className="text-[10px] uppercase tracking-[0.2em] text-[#50493b] subtitle">
          {label}
        </Label>
        <SaveIndicator state={state} fieldKey={fieldKey} />
      </div>
      {children}
      {error && (
        <p
          data-testid={`inline-error-${fieldKey}`}
          className="mt-1.5 text-[11px] text-[#b30035] font-body"
        >
          {error}
        </p>
      )}
    </div>
  );
}
